module.exports = __webpack_public_path__ + "static/img/product02_04.a354b35.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product02/product02_04.jpg
// module id = qP28
// module chunks = 1